import { BitbucketUser } from '@atlassian/cssxp-types-entitlement';
import { Results } from '@atlassian/cssxp-typescommon';

export const adminInitialState: any = {
  isSearching: false,
  error: null,
  results: [],
  totalHits: 0,
};
const SEARCH_ADMINS = 'SEARCH_ADMINS';
const SEARCH_MORE_ADMINS = 'SEARCH_MORE_ADMINS';
const SEARCH_ADMINS_FAILED = 'SEARCH_ADMINS_FAILED';

export const fetchInitialAdmins = (data: Results<BitbucketUser>) => ({
  type: SEARCH_ADMINS,
  data,
});

export const fetchAdminFailed = (error: Error) => ({
  type: SEARCH_ADMINS_FAILED,
  error,
});

export const fetchMoreAdmin = (data: Results<BitbucketUser>) => {
  if (!data) return;

  return {
    type: SEARCH_MORE_ADMINS,
    data,
  };
};

export const adminReducer = (
  state: { results: any },
  action: { type: string; data?: Results<BitbucketUser>; error?: Error } | undefined
) => {
  switch (action?.type) {
    case SEARCH_ADMINS:
      return action?.data;
    case SEARCH_MORE_ADMINS: {
      const results = action?.data?.results || [];
      if (results?.length > 0) {
        return {
          ...state,
          results: [...state.results, ...results],
        };
      }
      return state;
    }
    case SEARCH_ADMINS_FAILED: {
      return {
        ...state,
        error: action?.error,
      };
    }
    default:
      return state;
  }
};
